/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import MotiliButton from 'common/components-v2/buttons/MotiliButton';
import MotiliButtonContainer from 'common/components-v2/buttons/MotiliButtonContainer';
import FormTextArea from 'common/components/form/FormTextArea';
import FormSelect from 'common/components/form/FormSelect';
import { FormRow, FormElement } from 'common/components/form/FormLayout';
import Drawer from 'common/components-v2/modal/Drawer';

const AdminWorkOrderRequirementsChecklistRemoveModal = ({
    handleCloseOnClick,
    checklist,
    handleRemoveChecklistOnClick,
    isOpen,
}) => {
    const [reason, setReason] = useState('');
    const [otherReason, setOtherReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [uuid, setUuid] = useState('');

    const handleRemove = () => {
        setBusy(true);
        const reasonText =
            reason.id === 'OTHER' ? `Other - ${otherReason}` : reason.display;
        handleRemoveChecklistOnClick(checklist.id, reasonText).catch(() =>
            setBusy(false)
        );
    };

    useEffect(() => {
        if (isOpen) {
            setBusy(false);
            setReason('');
            setOtherReason('');
            setUuid(crypto.randomUUID());
        }
    }, [isOpen]);

    return (
        <Drawer
            onClose={handleCloseOnClick}
            title={`Remove Checklist ${checklist?.requirement?.name}`}
            closeByDocument={!busy}
            showClose={!busy}
            open={isOpen}
        >
            <FormRow>
                <FormElement>
                    <div>
                        <em>
                            Please select a reason for removing this checklist.
                        </em>
                    </div>
                </FormElement>
            </FormRow>
            <FormRow>
                <FormElement>
                    <FormSelect
                        controlId='checklist-remove-reason-select'
                        key={uuid}
                        label='REASON'
                        options={[
                            {
                                id: 'ENTERED_IN_ERROR',
                                display: 'Entered in Error',
                            },
                            {
                                id: 'TECHNICAL_ISSUES',
                                display: 'Technical Issues',
                            },
                            { id: 'OTHER', display: 'Other' },
                        ]}
                        onChange={value => setReason(value)}
                        value={reason}
                    />
                </FormElement>
            </FormRow>
            {reason && reason.id === 'OTHER' && (
                <FormRow>
                    <FormElement>
                        <FormTextArea
                            label='OTHER REASON'
                            value={otherReason}
                            onChange={e => setOtherReason(e.target.value)}
                        />
                    </FormElement>
                </FormRow>
            )}
            <MotiliButtonContainer styles={{ marginTop: '20px' }}>
                <MotiliButton
                    text='Cancel'
                    onClick={handleCloseOnClick}
                    disabled={busy}
                    moStyle='normal'
                />
                <MotiliButton
                    text='Remove'
                    onClick={handleRemove}
                    busy={busy}
                    disabled={
                        busy ||
                        !reason ||
                        (reason.id === 'OTHER' && !otherReason.trim())
                    }
                />
            </MotiliButtonContainer>
        </Drawer>
    );
};

AdminWorkOrderRequirementsChecklistRemoveModal.propTypes = {
    checklist: PropTypes.shape({
        id: PropTypes.number.isRequired,
        requirement: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    handleRemoveChecklistOnClick: PropTypes.func.isRequired,
    handleCloseOnClick: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};

export default AdminWorkOrderRequirementsChecklistRemoveModal;
